import { tryParseJson } from '../../../../../../../utils/json';
import { BlockCodeMirrorInnerField, LanguageMode } from '../CodeMirror/CodeMirror';
import { type ConfigFieldProps } from '../types';
import { useSelectedNodeField } from '../useSelectedNodeField';

interface DynamicFieldLiteralValueProps extends ConfigFieldProps {
  fieldId: string;
}

export function DynamicFieldLiteralValue(props: DynamicFieldLiteralValueProps) {
  const { fieldId, fieldName } = props;
  const { setValue } = useSelectedNodeField<unknown>(`${fieldName}.value`);
  return (
    <BlockCodeMirrorInnerField
      languageMode={LanguageMode.Json}
      fieldId={fieldId}
      fieldName={`${fieldName}.json`}
      minHeight="unset"
      basicSetup={{ foldGutter: true, lineNumbers: false }}
      label="Value as JSON"
      onChange={(json) => {
        setValue(tryParseJson(json).value);
      }}
    />
  );
}
